import React, { Fragment, useState, useEffect, useRef } from 'react';
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import cx from "classnames";
import { Col, Row, Button } from 'reactstrap';
import requestApi from "../../services/requestApi.service";
import { getSessionValue } from '../../Common/Appcommon';
import { dashboardFolderPermissionList } from './Constants';

const DashboardHeader = (props) => {
    let { folderData, closeModal, primaryLayout, graphLayout } = props;
    const [formData, setFormData] = useState({});
    const [selectedPermission, setSelectedPermission] = useState({});
    const [isDisablePermission, setDisablePermission] = useState(false);
    const { register, handleSubmit: handleActionFormSubmit, control, formState: { errors }, getValues } = useForm();
    useEffect(() => {
        (async () => {
            if (Object.keys(folderData).length > 0) {
                await loadFolderData();
            }
        })();
        return () => {
            // this now gets called when the component unmounts
        };

    }, [folderData]);

    const loadFolderData = async () => {
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "FOLDER_ACTION",
            "FOLDER_OPERATION": "GET_FOLDER",
            "folderid": folderData['value'],
        }
        let response = await requestApi.processServerRequest(params);
        if (response.issuccess) {
            let data = response.data;
            if (data.length > 0) {
                let folderInfo = data[0];
                let name = folderInfo['foldername'];
                let id = folderInfo['id'];
                let visibleType = folderInfo['visible_type'];
                let createdBy = folderInfo['createdby'];
                let currentUserId = getSessionValue('loginuserid');
                let fdata = {};
                fdata['id'] = id;
                fdata['folder_name'] = name;
                setFormData(fdata);
                setDisablePermission(createdBy !== currentUserId);
                setSelectedPermission({ value: visibleType, label: visibleType });
            }
        }
    }

    const onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const onPermissionChange = (selectedValue, fieldName) => {
        setSelectedPermission(selectedValue);
    }

    const submitForm = async (e) => {
        formData['visible_type'] = selectedPermission['value'];
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "FOLDER_ACTION",
            "FOLDER_OPERATION": "UPDATE",
            "data" : formData,
            "primaryLayout" : primaryLayout,
            "graphLayout" : graphLayout
        }
        let response = await requestApi.processServerRequest(params);
        if (response.issuccess) {
            let id = response.data;
            closeModal(false, id, formData.folder_name);
        }
    }
    return (
        <Fragment>
            <div className={cx("tab-listview-header header-btn")}>
                <div className='dashboard-header'>
                    <form id="folder-form" className='w-100' name="folder-form" onSubmit={handleActionFormSubmit(submitForm)}>
                        <Row>
                            <Col md="6">
                                <div className='folder-information d-flex-alone'>
                                    <div className='col-md-6'>
                                        <Controller
                                            name="folder_name"
                                            control={control}
                                            rules={{ required: formData.folder_name === undefined || formData.folder_name === "" ? "Please provide folder name" : false }}
                                            render={({ field }) => {
                                                return (
                                                    <input
                                                        {...field}
                                                        type="text"
                                                        name="folder_name"
                                                        id="folder_name"
                                                        value={formData.folder_name}
                                                        autoComplete={"off"}
                                                        onChange={(e) => {
                                                            field.onChange(e);
                                                            onInputChange(e);
                                                        }}
                                                        className={`form-control ${errors.folder_name ? 'is-invalid' : ''}`}
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.folder_name && <em className={`error invalid-feedback`}>{errors.folder_name.message}</em>}
                                    </div>
                                    <div className='col-md-4 ml-1'>
                                        <Controller
                                            name="permission"
                                            control={control}
                                            rules={{ required: Object.keys(selectedPermission).length === 0 ? "Please provide permission" : "" }}
                                            render={({ field }) => {
                                                return (
                                                    <Select
                                                        {...field}
                                                        placeholder={'---Choose One---'}
                                                        menuPlacement={"auto"}
                                                        menuPosition={'fixed'}
                                                        name={"permission"}
                                                        id={"permission"}
                                                        className={`basic-multi-select ${errors.permission ? 'is-invalid' : ''}`}
                                                        classNamePrefix="wa-select"
                                                        value={Object.keys(selectedPermission).length > 0 ? selectedPermission : dashboardFolderPermissionList[0]}
                                                        onChange={e => {
                                                            onPermissionChange(e, "permission");
                                                            field.onChange(e);
                                                        }}
                                                        isDisabled={isDisablePermission}
                                                        options={dashboardFolderPermissionList}
                                                    />
                                                );
                                            }}
                                        />
                                        {errors.permission && <em className={`error invalid-feedback`}>{errors.permission.message}</em>}
                                    </div>
                                </div>
                            </Col>
                            <Col md="6" className={"d-flex-alone justify-right"}>
                                <div className='btn-container'>
                                    <a className={`le-button lePrimaryBtn br-4 mr-1`} onClick={(e) => { closeModal(false, "layoutCancel") }}>
                                        {"Cancel"}
                                    </a>
                                    <Button className={`le-button lePrimaryBtn br-4`} color="primary" type={'submit'}>
                                        {"Save"}
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default DashboardHeader;